import { useState } from "react";
import { InputField, SubmitButton } from "../../../components";
import styles from "./EditCard.module.css";
import DatePickerInput from "../../../components/datePickerInput/DatePickerInput";
import { useRef } from "react";
import { CalendarIcon } from "../../../components/icons/Icons";

const initialValues = {
  cardNumber: "",
  expiryDate: "",
  cvvCode: "",
  cardHolderName: "",
};

const cardIcon = (
  <svg
    className={styles.inputIcon}
    viewBox="0 0 43 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.7944 5.114C42.7935 2.09708 41.2329 0.227689 38.7217 0.226562C27.363 0.226562 16.0032 0.226562 4.64448 0.226562C2.19822 0.227689 0.617893 2.12298 0.617893 5.05545C0.616952 12.6377 0.616952 20.2212 0.617893 27.8034C0.617893 30.7776 2.18598 32.6616 4.66707 32.6627C10.3314 32.665 15.9948 32.6639 21.6591 32.6639C27.3855 32.6639 33.112 32.6661 38.8384 32.6627C41.1868 32.6616 42.7944 30.7337 42.7954 27.9172C42.7973 20.3169 42.7963 12.7154 42.7944 5.114ZM41.2866 27.9893C41.2856 29.7134 40.3369 30.8587 38.9043 30.8587C27.4345 30.8609 15.9647 30.862 4.49388 30.8587C3.08862 30.8587 2.12669 29.71 2.1248 28.0298C2.1201 23.4306 2.12292 18.8315 2.12292 14.2335C2.12292 14.0882 2.12292 13.9429 2.12292 13.7706C15.1853 13.7706 28.2025 13.7706 41.2602 13.7706C41.2687 13.9272 41.2856 14.0882 41.2856 14.2492C41.2885 18.8292 41.2903 23.4093 41.2866 27.9893ZM2.16057 11.9136C2.16057 10.4496 2.16057 8.98004 2.16057 7.47214C15.1797 7.47214 28.2054 7.47214 41.2875 7.47214C41.2875 8.90459 41.2875 10.2909 41.2866 11.6783C41.2866 11.7492 41.2715 11.819 41.2612 11.9136C28.227 11.9136 15.2117 11.9136 2.16057 11.9136ZM41.2602 5.61063C28.2214 5.61063 15.2098 5.61063 2.19728 5.61063C1.76619 3.71534 2.86085 2.03176 4.54282 2.03176C13.1523 2.02838 21.7617 2.02951 30.3711 2.02951C33.0838 2.02951 35.7992 2.10609 38.509 2.00248C40.3171 1.93266 41.521 3.28403 41.2602 5.61063Z"
      className={styles.inputIconPath}
    />
    <path
      d="M18.4526 20.0605C15.644 20.0459 12.8354 20.0504 10.0267 20.0504C8.67703 20.0504 7.32824 20.0448 5.97852 20.0549C5.43072 20.0594 5.07776 20.5008 5.13988 21.065C5.19353 21.5583 5.50978 21.8511 6.02652 21.8522C8.09723 21.8567 10.1689 21.8545 12.2396 21.8545C13.3069 21.8545 14.3734 21.8545 15.4407 21.8545C16.5081 21.8545 17.5745 21.8556 18.6418 21.8522C19.0108 21.8511 19.3308 21.654 19.3788 21.2238C19.4127 20.9198 19.311 20.5155 19.1445 20.2846C19.0127 20.1033 18.6898 20.0616 18.4526 20.0605Z"
      className={styles.inputIconPath}
    />
    <path
      d="M14.7393 23.6578C11.8525 23.6556 8.96579 23.6556 6.07809 23.6589C5.48417 23.6601 5.14062 23.9968 5.14062 24.5587C5.14062 25.1207 5.48417 25.4574 6.07809 25.4585C7.52194 25.4619 8.96484 25.4596 10.4087 25.4596C11.8525 25.4596 13.2954 25.4619 14.7393 25.4585C15.3313 25.4574 15.6777 25.1184 15.6777 24.5576C15.6777 23.9968 15.3332 23.6589 14.7393 23.6578Z"
      className={styles.inputIconPath}
    />
    <path
      d="M34.2661 18.248C33.2675 18.248 32.3582 18.7109 31.6777 19.4643C30.9972 18.7098 30.088 18.248 29.0893 18.248C26.9876 18.248 25.2773 20.2942 25.2773 22.8089C25.2773 25.3236 26.9876 27.3698 29.0893 27.3698C30.088 27.3698 30.9972 26.9069 31.6777 26.1535C32.3582 26.9081 33.2675 27.3698 34.2661 27.3698C36.3679 27.3698 38.0781 25.3236 38.0781 22.8089C38.0781 20.2942 36.3679 18.248 34.2661 18.248ZM30.9699 25.095C30.4852 25.6659 29.8216 26.0184 29.0893 26.0184C27.6107 26.0184 26.4068 24.5781 26.4068 22.8089C26.4068 21.0397 27.6107 19.5994 29.0893 19.5994C29.8216 19.5994 30.4852 19.9519 30.9699 20.5228C30.6424 21.1952 30.4541 21.9767 30.4541 22.8089C30.4541 23.6411 30.6424 24.4227 30.9699 25.095ZM31.6777 23.6501C31.6165 23.3821 31.5836 23.0995 31.5836 22.8089C31.5836 22.5184 31.6165 22.2357 31.6777 21.9677C31.7389 22.2357 31.7718 22.5184 31.7718 22.8089C31.7718 23.0995 31.7389 23.3821 31.6777 23.6501ZM34.2661 26.0184C33.5338 26.0184 32.8703 25.6659 32.3855 25.095C32.7131 24.4227 32.9013 23.6411 32.9013 22.8089C32.9013 21.9767 32.7131 21.1952 32.3855 20.5228C32.8703 19.9519 33.5338 19.5994 34.2661 19.5994C35.7448 19.5994 36.9486 21.0397 36.9486 22.8089C36.9486 24.5781 35.7448 26.0184 34.2661 26.0184Z"
      className={styles.inputIconPath}
    />
  </svg>
);

const cvvCodeIcon = (
  <svg
    className={styles.inputIcon}
    viewBox="0 0 53 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6513 0.947098C27.1904 0.947098 32.7318 0.947098 38.271 0.949258C41.1949 0.949258 42.6036 2.33863 42.6123 5.23406C42.6189 7.53743 42.6145 9.84081 42.6123 12.1442C42.6102 15.3875 41.2862 16.6926 37.9819 16.6948C28.46 16.6969 18.936 16.6969 9.41417 16.6969C7.85763 16.6969 6.29892 16.7185 4.74238 16.6904C2.12496 16.6364 0.657553 15.1455 0.648857 12.5569C0.640161 10.0374 0.635814 7.51799 0.648857 4.99853C0.661901 2.4834 2.17713 0.957902 4.70542 0.951419C10.3533 0.936294 16.0034 0.947098 21.6513 0.947098ZM21.6665 3.41901C16.0882 3.41901 10.5077 3.41685 4.92934 3.42117C3.56193 3.42334 3.19236 3.7885 3.18584 5.14763C3.17714 7.59577 3.17497 10.0461 3.18584 12.4942C3.19236 13.8361 3.5728 14.212 4.94455 14.212C16.0664 14.2164 27.1904 14.2164 38.3123 14.212C39.7232 14.212 40.1341 13.8123 40.1406 12.4229C40.1536 10.0461 40.1515 7.66924 40.1428 5.2924C40.1362 3.77554 39.7623 3.41901 38.1884 3.41901C32.6796 3.41685 27.1731 3.41901 21.6665 3.41901Z"
      className={styles.inputIconPath}
    />
    <path
      d="M44.4142 8.94569C44.4142 8.06194 44.4142 7.34889 44.4142 6.56669C46.4968 6.56669 48.5838 6.43272 50.6425 6.61639C51.9317 6.73091 52.7686 7.98199 52.773 9.38001C52.7969 16.1108 52.8121 22.8416 52.7643 29.5724C52.7513 31.4954 51.3186 32.6774 49.2056 32.6795C42.3251 32.6903 35.4445 32.686 28.564 32.686C23.3488 32.686 18.1335 32.6882 12.9204 32.6839C10.2639 32.6817 9.1008 31.5127 9.09862 28.8571C9.09645 25.7262 9.09862 22.5931 9.09862 19.4621C9.09862 19.1121 9.09862 18.7599 9.09862 18.3493C9.94211 18.3493 10.6834 18.3493 11.5269 18.3493C11.5465 18.7577 11.5791 19.1402 11.5791 19.5226C11.5834 22.619 11.603 25.7132 11.5682 28.8096C11.5573 29.7906 11.8334 30.2336 12.9226 30.2314C24.9097 30.2033 36.8967 30.2033 48.8816 30.2292C49.923 30.2314 50.273 29.8965 50.2686 28.8593C50.236 22.5974 50.236 16.3334 50.273 10.0693C50.2795 9.14448 49.9621 8.89383 49.0838 8.92624C47.5708 8.98675 46.0534 8.94569 44.4142 8.94569Z"
      className={styles.inputIconPath}
    />
    <path
      d="M13.7852 27.751C13.7852 26.9796 13.7852 26.2428 13.7852 25.4238C17.6656 25.4238 21.5092 25.4238 25.4309 25.4238C25.4309 26.1909 25.4309 26.9277 25.4309 27.751C21.5787 27.751 17.7113 27.751 13.7852 27.751Z"
      className={styles.inputIconPath}
    />
    <path
      d="M28.2031 27.78C28.2031 26.9459 28.2031 26.235 28.2031 25.4355C32.0858 25.4355 35.9249 25.4355 39.8489 25.4355C39.8489 26.2026 39.8489 26.9632 39.8489 27.78C35.9706 27.78 32.1271 27.78 28.2031 27.78Z"
      className={styles.inputIconPath}
    />
    <path
      d="M40.7852 19.7383C40.7852 20.5615 40.7852 21.3027 40.7852 22.1173C39.0265 22.1173 37.3135 22.1173 35.5156 22.1173C35.5156 21.3459 35.5156 20.581 35.5156 19.7383C37.2374 19.7383 38.9504 19.7383 40.7852 19.7383Z"
      className={styles.inputIconPath}
    />
    <path
      d="M19.0634 19.7246C19.0634 20.5695 19.0634 21.3106 19.0634 22.1187C17.3047 22.1187 15.5938 22.1187 13.8047 22.1187C13.8047 21.3236 13.8047 20.5608 13.8047 19.7246C15.5591 19.7246 17.2656 19.7246 19.0634 19.7246Z"
      className={styles.inputIconPath}
    />
    <path
      d="M33.5221 19.7305C33.5221 20.5386 33.5221 21.3078 33.5221 22.1311C31.7612 22.1311 30.0743 22.1311 28.3047 22.1311C28.3047 21.3424 28.3047 20.5732 28.3047 19.7305C30.0199 19.7305 31.7352 19.7305 33.5221 19.7305Z"
      className={styles.inputIconPath}
    />
    <path
      d="M26.283 19.7246C26.283 20.5414 26.283 21.2825 26.283 22.1058C24.5569 22.1058 22.8547 22.1058 21.0742 22.1058C21.0742 21.3171 21.0742 20.5543 21.0742 19.7246C22.7938 19.7246 24.4699 19.7246 26.283 19.7246Z"
      className={styles.inputIconPath}
    />
    <path
      d="M12.0678 13.6039C11.4895 12.8303 10.9547 12.1151 10.3439 11.2983C9.73082 12.1108 9.18081 12.8411 8.60472 13.6039C7.93732 13.1198 7.32862 12.679 6.62861 12.1734C7.16992 11.3891 7.68949 10.6371 8.26124 9.80739C7.34166 9.49407 6.5047 9.20885 5.55469 8.88474C5.79817 8.10902 6.02861 7.37868 6.2873 6.55975C7.24384 6.84282 8.09384 7.09346 9.06777 7.38301C9.06777 6.3977 9.06777 5.52043 9.06777 4.57617C9.91125 4.57617 10.6526 4.57617 11.5243 4.57617C11.5243 5.44912 11.5243 6.32639 11.5243 7.40677C12.5656 7.10211 13.4352 6.84714 14.3874 6.5684C14.6439 7.36788 14.8722 8.07229 15.1287 8.87177C14.2222 9.18941 13.3852 9.48327 12.433 9.81603C12.9765 10.6047 13.4982 11.361 14.0548 12.1713C13.3787 12.6596 12.7417 13.1177 12.0678 13.6039Z"
      className={styles.inputIconPath}
    />
    <path
      d="M25.0276 6.56408C25.2863 7.36788 25.5145 8.07229 25.7754 8.8869C24.8624 9.19589 24.021 9.47895 23.0623 9.80306C23.6123 10.6025 24.1341 11.3567 24.695 12.1713C24.0145 12.6639 23.3819 13.122 22.7145 13.606C22.1297 12.8303 21.5928 12.1151 20.9797 11.3026C20.3732 12.1064 19.8232 12.8389 19.2471 13.606C18.5797 13.1263 17.9688 12.6877 17.2688 12.1842C17.8123 11.3912 18.3318 10.6371 18.9014 9.80739C17.9905 9.49624 17.1536 9.21318 16.1992 8.8869C16.4384 8.11551 16.6666 7.38301 16.921 6.56192C17.8753 6.84498 18.7253 7.09779 19.7058 7.38733C19.7058 6.3977 19.7058 5.52043 19.7058 4.57617C20.5558 4.57617 21.2949 4.57617 22.1623 4.57617C22.1623 5.45344 22.1623 6.33071 22.1623 7.41758C23.2058 7.10859 24.0754 6.84714 25.0276 6.56408Z"
      className={styles.inputIconPath}
    />
    <path
      d="M27.5742 6.55298C28.5633 6.84684 29.4112 7.09965 30.396 7.39136C30.396 6.37148 30.396 5.48988 30.396 4.55859C31.2416 4.55859 31.9829 4.55859 32.846 4.55859C32.846 5.48124 32.846 6.36067 32.846 7.38704C33.846 7.09965 34.6938 6.85765 35.6634 6.57891C35.9178 7.35246 36.1569 8.07848 36.4243 8.88661C35.4764 9.2064 34.6395 9.48946 33.6916 9.80925C34.259 10.6087 34.7721 11.3348 35.3525 12.1537C34.6851 12.642 34.059 13.0979 33.3656 13.6036C32.7764 12.8235 32.2221 12.091 31.6221 11.2937C31.0264 12.091 30.4894 12.8062 29.9025 13.5928C29.2307 13.1131 28.5981 12.6615 27.9003 12.1623C28.4546 11.378 28.9677 10.6498 29.5568 9.81574C28.6372 9.49594 27.7851 9.19776 26.8438 8.87148C27.0851 8.10657 27.309 7.4 27.5742 6.55298Z"
      className={styles.inputIconPath}
    />
  </svg>
);

const EditCard = () => {
  const [inputs, setInputs] = useState(initialValues);
  const [inputData, setInputData] = useState(true);

  const onChange = (date, dateString) => {
    setInputs((prev) => ({ ...prev, expiryDate: dateString }));
  };

  function handleValues(e) {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit() {
    console.log(inputs);
    setInputs();
    setInputData((prev) => !prev);
  }

  return (
    <>
      <div className={styles.inputs} key={inputData}>
        <InputField
          label="Card Number"
          type="number"
          name="cardNumber"
          inputWidth="100%"
          rightIcon={cardIcon}
          maxLength="13"
          onChange={handleValues}
        />
        <DatePickerInput
          label="Expiry Date"
          onChange={onChange}
          icon={<CalendarIcon size={20} />}
          format="month"
          inputWidth="48%"
        />
        <InputField
          label="CVV Code"
          type="number"
          name="cvvCode"
          inputWidth="48%"
          rightIcon={cvvCodeIcon}
          onChange={handleValues}
        />
        <InputField
          label="Card Holder Name"
          type="text"
          name="cardHolderName"
          inputWidth="100%"
          rightIcon={cardIcon}
          onChange={handleValues}
        />
      </div>
      <SubmitButton
        title={"Edit Card"}
        btnClass={styles.solidBtn}
        onClick={handleSubmit}
      />
    </>
  );
};

export default EditCard;
